import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'

const PageConst= {
  ACTION: {
    getEdit: { api: 'T0060SeminarCalendarService.M20801_getEdit'},
    doDelete: { api: 'T0060SeminarCalendarService.M20801_doDelete'},
    doBrowse: { api: 'T0060SeminarCalendarService.M20801_doBrowse'},
  },
}

const module = {
  state: {
    PageConst,
    dropdownList: {
      centers: []
    },
    defaultDoBrowse: {
      searchInfo: {
        showPrevious: false
      },
      orderBy: {},
      doBrowseStatus: 'init',
      errorMessage: {},
    },
    rawTimeLimitList: [],
  },

  getters: {},

  mutations: {},

  actions: {
    async initData ({ state }, payload) {
      return await ApiUtils.postData({
        data: [
          {
            api: 'M0040TimeLimitService.doBrowseAll',
            input: {
              searchInfo: {
                not_time_division: 0
              }
            }
          }
        ]
      }).then((data) => {
        state.rawTimeLimitList = data[0].output
      })
    },
    async M20801_doBrowse_AtDataTable({dispatch, state}) {
      return await dispatch('doBrowse_AtDataTable', {
        orderBy: state.orderBy,
        pagination: state.pagination
      });
    },
    async doSave ({ state }, payload) {
      return await ApiUtils.postData({
        data: [{ api: 'T0060SeminarCalendarService.M20801_doSave', input: payload }]
      })
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
